import { http } from '@/app/lib/http/client'

export interface Category {
    id: number
    name: string
    description: string
    slug: string
    is_active: boolean
    created_at: string
    updated_at: string
}

export interface CreateCategoryPayload {
    name: string
    description?: string
    is_active?: boolean
}

export interface UpdateCategoryPayload {
    name?: string
    description?: string
}

import { ListParams } from '../types/pagination'

export const categoryService = {
    async getCategories(params?: ListParams) {
        const response = await http.get('/categories', { params })
        return response.data
    },

    async getCategory(id: number) {
        const response = await http.get(`/categories/${id}`)
        return response.data
    },

    async createCategory(payload: CreateCategoryPayload) {
        const response = await http.post('/categories', payload)
        return response.data
    },

    async updateCategory(id: number, payload: UpdateCategoryPayload) {
        const response = await http.put(`/categories/${id}`, payload)
        return response.data
    },

    /**
     * Cambia el estado is_active de la categoria.
     * Si se omite `is_active` en el payload, el backend invierte el valor actual.
     * Si se provee explicitamente, establece ese valor exacto.
     */
    async updateStatus(id: number, isActive?: boolean) {
        const payload = isActive !== undefined ? { is_active: isActive } : {}
        const response = await http.patch(`/categories/${id}/status`, payload)
        return response.data
    },

    async deleteCategory(id: number) {
        const response = await http.delete(`/categories/${id}`)
        return response.data
    },
}
